// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f6123627","455":"91d6d2d7"}[chunkId] + ".chunk.js";
};